<template>
  <div class="home">
    <SplashScreen
      :imgUrl="require(`@/assets/splash-screen.png`)"
      :isActive="this.isSplashScreenActive"
      :onClick="this.disableSplashScreen"/>
    <div class="meter-wrapper" :style="{'background-image': 'url(' + baseUrl + 'images/wood-texture.jpg)'}">
      <div class="padding">
      </div>
      TIMER
      <div id="timer-wrapper">
        <Timer ref="timer"></Timer>
      </div>
      ACCURACY
      <div id="thermometer-wrapper">
        <Thermometer :value="accuracy" type="human" :threshold="aiAccuracy"/>
        <Thermometer :value="aiAccuracy" type="ai"/>

      </div>
      MISSION
      <input id='pair-number' type='text' v-model='missionNumber'/>
    </div>




    <div class="info">
      Missions solved: {{ solved }}<br>
      Missions skipped: {{ skipped }}<br>
      Missions inspected: {{ inspected }}<br>
      Missions w defect: {{ '[' + artefactsl.toString() + ']' }} <br>
      Missions w proper Motions: {{ '[' +  pmsl.toString()  + ']' }} <br>
      Missions w vanished central object: {{ '[' +  vanishedl.toString()  + ']' }} <br>
    </div>
    <StarMatching
      :filters='this.$store.state.filters'
      :usnoSrc='this.usnoSrc'
      :panstarrSrc='this.panstarrSrc'
      :isAccuracyValid='this.isAccuracyValid'
      @next='next'
      @accuracy-change='handleAccuracyChange'
      @aiAccuracy='setAiAccuracy'/>
    <div class="fixed-wrapper">
      <div v-if="this.$store.state.isLoading"> <p> <center>  ... Loading Images from a server Far Far away ... </center> </p></div>
      <div v-else>
        <center><p>
        Focus on the central object in the left image.
          Now compare to the right image.
          Which option fits best?
        </p>
        <div class="button-wrapperx">
              <button class="buttonx" id="b1" :disabled="nothing_status" @click="nothingf">1. The object is still there.</button>
              <button class="buttonx" id="b2" :disabled="artefact_status" @click="artefactsf">2. The image has a defect.</button>
              <button class="buttonx" id="b3" :disabled="pms_status" @click="pmsf">3. It has moved!</button>
              <button class="buttonx" id="b4" :disabled="vanished_status" @click="vanishedf">4. It has vanished!</button>
              <button class="buttonx" id="b5" :disabled="other_status" @click="otherf">5. Other.</button>
        </div></center>
      </div>
      <center>
      <p> </p>
      <div class="button-wrapperx">
            <button class="buttony" id="inspect" @click="next">Submit</button>
            <button class="button" id="b6" @click="cancelMission">Restart mission</button>
            <button class="button" id="inspect" @click="inspect">Inspect</button>
      </div></center>
    </div>
  </div>
</template>

<script>
import SplashScreen from '@/components/SplashScreen.vue'
import StarMatching from '@/components/StarMatching.vue'
import Timer from '@/components/Timer.vue'
import Thermometer from '@/components/Thermometer.vue'
import {mapState, mapActions} from 'vuex'
import {debounce} from 'lodash'

export default {
  name: 'home',
  components: {
    SplashScreen,
    StarMatching,
    Timer,
    Thermometer
  },
  data: function() {
    return {
      baseUrl: process.env.BASE_URL,
      debounced: null, // A reference to a method that is debounced (useful to cancel it in case the action is executed again)
      aiAccuracy: 0,
      artefactsl: [],
      pmsl: [],
      vanishedl: [],
      other_status: false,
      vanished_status: false,
      artefact_status: false,
      pms_status: false,
      nothing_status: false,
    }
  },
  computed: {
    ...mapState({
      accuracy: ({accuracy}) => accuracy,
      isAccuracyValid: ({isAccuracyValid}) => isAccuracyValid,
      isSplashScreenActive: ({splashScreen}) => splashScreen.isActive,
      imageKey: ({candidate}) => candidate.item.imageKey,
      usnoSrc: function() { return this.$store.getters.img1},
      panstarrSrc: function() { return this.$store.getters.img2},
    }),
    solved: function () {
      return this.$store.state.solved;
    },
    skipped: function () {
      return this.$store.state.skipped;
    },
    inspected: function () {
      return this.$store.state.inspected;
    },
    missionNumber: {
      get: function () { return this.imageKey },
      set: function (imageKey) {
        // Cancel previously debounced call (if any)
        if(this.debounced && this.debounced.cancel) {
          this.debounced.cancel()
        }
        // (Re-)register debounce method
        this.debounced = debounce((k) => this.setNextCandidate(k), 500)
        // Execute debounced method
        this.debounced(imageKey)
      }
    }
  },
  methods: {
    ...mapActions([
      'disableSplashScreen',
      'createMission',
      'getNextCandidate',
      'setNextCandidate',
      'setAccuracy',
      'update_loading'
    ]),
    setAiAccuracy: function (accuracy) {
      this.aiAccuracy = accuracy;
    },
    // Return true if the accuracy of a matching is at least as good as the
    // accuracy threshold, false otherwise
    isMatchingSuccessful() {
      return (this.accuracy >= this.aiAccuracy)
    },
    async next () {
      this.$refs.timer.resetTimer()
      this.$refs.timer.startTimer()
      if (this.isMatchingSuccessful()) {
        this.$store.commit('UpSolved');
      } else {
        this.$store.commit('UpSkipped');
      }
      this.createMission(this.$store.state)
      this.getNextCandidate()
      this.other_status = false
      this.vanished_status = false
      this.artefact_status = false
      this.pms_status = false
      this.nothing_status = false
      this.$store.dispatch('toggleLoading',true)
    },
    postURL: function(url,data=[]) {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, false);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify({value: data}));
    },
    dateYYMMDD: function() {
      var x = new Date();
      var y = x.getFullYear().toString();
      var m = (x.getMonth() + 1).toString();
      var d = x.getDate().toString();
      if (d.length == 1) {d = '0' + d;}
      if (m.length == 1) {m = '0' + m;}
      var yyyymmdd = y + m + d;
      return yyyymmdd;
    },

    nothingf: function () {
      console.log("write to report.txt")
      this.other_status = true
      this.vanished_status = true
      this.artefact_status = true
      this.pms_status = true
      this.nothing_status = true
      this.postURL('http://35.228.113.10/report.php?image=' + this.imageKey + '&date=' + this.dateYYMMDD() + '&report=!nothing!')
      console.log("write to report.txt OK")
    },
    vanishedf: function () {
      console.log("write to report.txt")
      this.other_status = true
      this.vanished_status = true
      this.artefact_status = true
      this.pms_status = true
      this.nothing_status = true
      this.postURL('http://35.228.113.10/report.php?image=' + this.imageKey + '&date=' + this.dateYYMMDD() + '&report=!vanished!')
      this.vanishedl.push(this.imageKey)
      console.log("write to report.txt OK")
    },
    pmsf: function () {
      console.log("write to report.txt")
      this.other_status = true
      this.vanished_status = true
      this.artefact_status = true
      this.pms_status = true
      this.nothing_status = true
      this.postURL('http://35.228.113.10/report.php?image=' + this.imageKey + '&date=' + this.dateYYMMDD() + '&report=!motion!')
      this.pmsl.push(this.imageKey)
      console.log("write to report.txt OK")
    },
    artefactsf: function () {
      console.log("write to report.txt")
      this.other_status = true
      this.vanished_status = true
      this.artefact_status = true
      this.pms_status = true
      this.nothing_status = true
      this.postURL('http://35.228.113.10/report.php?image=' + this.imageKey + '&date=' + this.dateYYMMDD() + '&report=!artefact!')
      this.artefactsl.push(this.imageKey)
      console.log("write to report.txt OK")
    },
    otherf: function () {
      console.log("write to report.txt")
      this.other_status = true
      this.vanished_status = true
      this.artefact_status = true
      this.pms_status = true
      this.nothing_status = true
      this.postURL('http://35.228.113.10/report.php?image=' + this.imageKey + '&date=' + this.dateYYMMDD() + '&report=!other!')
      console.log("write to report.txt OK")
    },
    cancelMission: function () {
      if (this.vanishedl[this.vanishedl.length-1]==this.imageKey) this.vanishedl.pop()
      if (this.artefactsl[this.artefactsl.length-1]==this.imageKey) this.artefactsl.pop()
      if (this.pmsl[this.pmsl.length-1]==this.imageKey) this.pmsl.pop()
      console.log("write to report.txt")
      this.vanished_status = false
      this.artefact_status = false
      this.pms_status = false
      this.nothing_status = false
      this.postURL('http://35.228.113.10/report.php?image=' + this.imageKey + '&date=' + this.dateYYMMDD() + '&report=!cancel!')
      console.log("write to report.txt OK")
    },
    inspect () {
      this.$store.commit('inspected')
      const routeData = this.$router.resolve({
        name: 'inspect',
        params: {imageKey: this.imageKey}
      })
      window.open(routeData.href, '_blank')
    },
    // Handle images' matching accuracy change
    handleAccuracyChange ({accuracy, isAccuracyValid}) {
      this.setAccuracy({accuracy, isAccuracyValid})
      if (this.isMatchingSuccessful()) {
        this.$refs.timer.stopTimer()
      } else {
        this.$refs.timer.startTimer()
      }
    },
  }
}

</script>
<style scoped>
  .info {
    font-family: 'Overpass Mono', monospace;
    font-size: 8pt;
    position: fixed;
    text-align: right;
    top: 4em;
    right:100px;
    max-width: 50vw;
    color: #668866;
  }
  #done {
    text-transform: uppercase;
    margin-right:17px;
  }
  #done:hover {
    background: linear-gradient(to bottom, #B87333 0%, #A96424 100%);
  }

  #fail {
    text-transform: uppercase;
    color: #932c29;
    text-shadow: 1px 1px 1px rgba(255,255,255,0.5);
    border-radius: 3px;
    box-shadow: 0px 0px 5px #d09156;
  }
  #fail:hover {
    background: linear-gradient(to bottom, #B87333 0%, #A96424 100%);
  }
  #timer-wrapper {
    display: inline-block;
    margin:0.5em 0.5em 1em;
  }
  #thermometer-wrapper {
    display: grid;
    margin: 0.5em auto 1em 1em;
    grid-template-columns: 50% 50%;
  }
  #pair-number {
    border:0;
    margin-top:0.5em;
    font-size: 18px;
    height:24px;
    width:66px;
    line-height: 24px;
    font-family: 'Overpass Mono', monospace;
    color: #99ee99;
    text-align: center;
    background: #342;
    /*box-shadow: 0 0 10px #897;*/
    box-shadow: 0 0 10px #1d2316a8;
    text-shadow: 0 0 10px #99ee99;
    position: relative;
    z-index:100;
    outline: none;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  .meter-wrapper {
    font-family: 'Overpass Mono', monospace;
    color: #200;
    text-shadow: 1px 1px 1px rgba(255,255,255,0.5);
    width:80px;
    height:100vh;
    text-align: center;
    right: 0;
    top:0;
    position: absolute;
    box-shadow: inset 0 0 7px #000;
    z-index:2;
  }
</style>
